import { createStyles } from '../helpers'

import { darkGrey, grey, mediumGrey, textGrey } from '../const/colors'
import { expandRowLeftPadding, rowLeftPadding } from '../../components/Table/styles'

// when table is inserted into another table
export const subTable = {
  border: 'none',
  borderRadius: 0, // remove round corners
  paddingLeft: expandRowLeftPadding - rowLeftPadding // align the sub table rows with the parent table
}

const useStyles = createStyles({
  noDataContent: {
    color: mediumGrey,
    fontWeight: 600
  },
  mainText: {
    color: textGrey,
    fontSize: '14px',
    fontWeight: 600
  },
  infoText: {
    color: darkGrey,
    fontSize: '12px',
    fontWeight: 400
  },
  noDataContentInTheMiddleOfTheTable: {
    color: mediumGrey,
    fontWeight: 600,
    display: 'flex',
    width: '100%',
    justifyContent: 'center',
    alignItems: 'center',
    paddingTop: '40px'
  },
  noDataDark: {
    color: grey
  }
})

export default useStyles
